import React, { useState } from "react";
import "./logistic_dashboard.css";
import NewOrder from "./new_order";
import Requests from "./Requests";
import Transporters from "./Transporters";
import TransportOrders from "./transport_orders";
import Tracking from "./Tracking";
import Issues from "./issues";
import Routes from "./routes";
import TransportDocuments from "./documents";

const sidebarSections = [
  {
    title: "PARTNERS",
    items: ["Transporters"],
  },
  {
    title: "OPERATIONS",
    items: ["Transport Orders", "Live Tracking"],
  },
  {
    title: "DOCUMENTS",
    items: ["Bills & POD"],
  },
  {
    title: "MANAGEMENT",
    items: ["Issues and Credit Notes", "Add Route"],
  },
];

const LogisticDashboard = () => {
  const [selectedPage, setSelectedPage] = useState("Transport Orders");
  const [activeTopPage, setActiveTopPage] = useState("");

  return (
    <div className="logistics-dashboard-layout light-theme-dashboard">
      {/* SIDEBAR */}
      <aside className="dashboard-sidebar">
        <div className="sidebar-logo">
          <div className="logo-circle">FL</div>

          <div>
            <h2>FindLorry</h2>
            <p>Transport Dashboard</p>
          </div>
        </div>

        <div className="sidebar-sections">
          {sidebarSections.map((section) => (
            <div key={section.title} className="sidebar-group">
              <h4>{section.title}</h4>

              <div className="sidebar-links">
                {section.items.map((item) => (
                  <button
                    key={item}
                    className={`sidebar-link-btn ${
                      selectedPage === item ? "active" : ""
                    }`}
                    onClick={() => {
                      setSelectedPage(item);
                      setActiveTopPage("");
                    }}
                  >
                    {item}
                  </button>
                ))}
              </div>
            </div>
          ))}
        </div>
      </aside>

      {/* MAIN CONTENT */}
      <main className="dashboard-main-content dashboard-content-card">
        {/* TOP BAR */}
        <div className="dashboard-topbar dashboard-topbar-modern">
          <div className="topbar-left">
            <h1>Logistics Panel</h1>
            <p>Realtime logistics management workspace</p>
          </div>

          <div className="topbar-actions responsive-actions">
            <button
              className="primary-btn"
              onClick={() => {
                setSelectedPage("");
                setActiveTopPage("create-order");
              }}
            >
              <span>+</span>
              Create Order
            </button>

            <button
              className="primary-btn"
              onClick={() => {
                setSelectedPage("");
                setActiveTopPage("requests");
              }}
            >
              <span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M10 17h4V5H2v12h3" />
                  <path d="M14 8h4l4 4v5h-2" />
                  <circle cx="7.5" cy="17.5" r="2.5" />
                  <circle cx="17.5" cy="17.5" r="2.5" />
                </svg>
              </span>
              Requests
            </button>
          </div>
        </div>

        {/* MAIN WINDOW */}
        {activeTopPage === "create-order" ? (
          <NewOrder />
        ) : activeTopPage === "requests" ? (
          <Requests />
        ) : selectedPage === "Transporters" ? (
          <Transporters />
        ) : selectedPage === "Bills & POD" ? (
          <TransportDocuments />
        ) : selectedPage === "Transport Orders" ? (
          <TransportOrders />
        ) : selectedPage === "Live Tracking" ? (
          <Tracking />
        ) : selectedPage === "Issues and Credit Notes" ? (
          <Issues />
        ) : selectedPage === "Add Route" ? (
          <Routes />
        ) : (
          <>
            <div className="main-window-header">
              <h2>{selectedPage}</h2>
              <p>Page container ready for database integration</p>
            </div>

            <div className="main-page-demo-box">
              <h3>{selectedPage} Page</h3>
              <p>
                This area will later render live database connected content.
              </p>
            </div>
          </>
        )}
      </main>
    </div>
  );
};

export default LogisticDashboard;